import React from 'react'
import APIDataTablesContainer from '../../../../Components/Tables/DataTables/APIDataTables'

export default function APIDataTables() {
  return (
    <div className='page-body'>
        <APIDataTablesContainer/>
    </div>
  )
}
